import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-05fdf3c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-align-center" }
const _hoisted_2 = {
  class: "",
  style: {"padding":"10px 16px","height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsCards = _resolveComponent("StatisticsCards")!
  const _component_SystemVersionDistributionChart = _resolveComponent("SystemVersionDistributionChart")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_OnlineOfflineTrendChart = _resolveComponent("OnlineOfflineTrendChart")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_GroupClientTerminalListSection = _resolveComponent("GroupClientTerminalListSection")!
  const _component_Card = _resolveComponent("Card")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_InOutLog = _resolveComponent("InOutLog")!
  const _component_ClientRegisteInfoModal = _resolveComponent("ClientRegisteInfoModal")!
  const _component_ClientShutDownModal = _resolveComponent("ClientShutDownModal")!
  const _component_ClientRebootModal = _resolveComponent("ClientRebootModal")!
  const _component_ClientBlackListModal = _resolveComponent("ClientBlackListModal")!
  const _component_ClientDeleteModal = _resolveComponent("ClientDeleteModal")!
  const _component_ClientDefencePolicyModal = _resolveComponent("ClientDefencePolicyModal")!
  const _component_ClientMoveTerminalModal = _resolveComponent("ClientMoveTerminalModal")!
  const _component_MessagePushModal = _resolveComponent("MessagePushModal")!
  const _component_RemoteAssist = _resolveComponent("RemoteAssist")!
  const _component_TerminalInfo = _resolveComponent("TerminalInfo")!
  const _component_ServiceManage = _resolveComponent("ServiceManage")!
  const _component_LocationInfo = _resolveComponent("LocationInfo")!
  const _component_FleetMap = _resolveComponent("FleetMap")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_StatisticsCards, {
      "total-terminals": _ctx.statistics.totalTerminals,
      "online-count": _ctx.statistics.onlineCount,
      "offline-count": _ctx.statistics.offlineCount,
      "today-join-count": _ctx.statistics.todayJoinCount,
      "today-leave-count": _ctx.statistics.todayLeaveCount,
      "buy-count": _ctx.statistics.buyCount,
      "exceed-count": _ctx.statistics.exceedCount,
      "expire-count": _ctx.statistics.expireCount,
      "peripherals-approval-count": _ctx.statistics.peripheralsApprovalCount,
      "send-file-approval-count": _ctx.statistics.sendFileApprovalCount,
      "hide-subscribe-card": !_ctx.HIDE_FUNC.service__subscribe,
      onStatClick: _ctx.handleGroupClientStatClick
    }, null, 8, ["total-terminals", "online-count", "offline-count", "today-join-count", "today-leave-count", "buy-count", "exceed-count", "expire-count", "peripherals-approval-count", "send-file-approval-count", "hide-subscribe-card", "onStatClick"]),
    _createVNode(_component_el_row, {
      gutter: 16,
      class: "charts-row"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_SystemVersionDistributionChart, {
              data: _ctx.systemVersionData,
              onSliceClick: _ctx.handleSystemVersionSliceClick
            }, null, 8, ["data", "onSliceClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_OnlineOfflineTrendChart, {
              data: _ctx.onlineOfflineTrendData,
              modelValue: _ctx.timeRange,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timeRange) = $event)),
              onTimeRangeChange: _ctx.handleTimeRangeChange
            }, null, 8, ["data", "modelValue", "onTimeRangeChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Card, {
      class: "table-criteria",
      size: "second",
      title: _ctx.$t('groupClient.terminalListCardTitle')
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, {
          size: "small",
          class: "cm-ui-ml8"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        }),
        (_ctx.total > 0 && _ctx.statistics.expire_terminal_count && _ctx.IS_JP_ONLY_BUILD)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              size: "small",
              style: {"display":"flex","align-items":"center","gap":"3px"},
              type: "danger"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CmSvgIcon, {
                  name: "assets/icons/info-gray",
                  size: 17
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('groupClient.limitExceeded')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_GroupClientTerminalListSection, {
          ref: "multipleTable",
          "view-mode": _ctx.TableViewMode.preview,
          rows: _ctx.tableData,
          loading: _ctx.loading,
          "page-row-count": _ctx.tableData.length,
          total: _ctx.total,
          "load-more-config": null,
          "load-more-has-more": false,
          "load-more-loading": false,
          "load-more-current": 0,
          "load-more-total": 0
        }, null, 8, ["view-mode", "rows", "loading", "page-row-count", "total"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.terminalListDrawerVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.terminalListDrawerVisible) = $event)),
      size: "80%",
      title: _ctx.$t('groupClient.fullTerminalList'),
      "destroy-on-close": "",
      class: "terminal-list-drawer"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.$t('groupClient.fullTerminalList')) + " ", 1),
          (_ctx.total > 0 && _ctx.statistics.expire_terminal_count && _ctx.IS_JP_ONLY_BUILD)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 0,
                class: "cm-ui-ml15",
                size: "small",
                style: {"display":"flex","align-items":"center","gap":"3px","width":"max-content"},
                type: "danger"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CmSvgIcon, {
                    name: "assets/icons/info-gray",
                    size: 17
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('groupClient.limitExceeded')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_GroupClientTerminalListSection, {
            ref: "multipleTableDrawer",
            "view-mode": _ctx.TableViewMode.full,
            rows: _ctx.drawerRows,
            loading: _ctx.drawerLoadingFlag,
            "page-row-count": _ctx.drawerRows.length,
            total: _ctx.total,
            "load-more-config": _ctx.drawerLoadMoreConfig,
            "load-more-has-more": _ctx.drawerHasMore,
            "load-more-loading": _ctx.drawerLoadingFlag,
            "load-more-current": _ctx.drawerRows.length,
            "load-more-total": _ctx.drawerTotalCount,
            onLoadMore: _ctx.handleDrawerLoadMore
          }, null, 8, ["view-mode", "rows", "loading", "page-row-count", "total", "load-more-config", "load-more-has-more", "load-more-loading", "load-more-current", "load-more-total", "onLoadMore"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.inOutLogDrawerVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inOutLogDrawerVisible) = $event)),
      size: "80%",
      title: _ctx.inOutLogDrawerTitle,
      "destroy-on-close": "",
      class: "terminal-list-drawer in-out-log-stat-drawer"
    }, {
      default: _withCtx(() => [
        (_ctx.inOutLogDrawerVisible && _ctx.inOutLogEmbedDefaults)
          ? (_openBlock(), _createBlock(_component_InOutLog, {
              key: 0,
              "embed-defaults": _ctx.inOutLogEmbedDefaults
            }, null, 8, ["embed-defaults"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_ClientRegisteInfoModal, {
      show: _ctx.clientModal.MODAL_CLIENT_REGISTE_INFO,
      onCloseClientModal: _ctx.closeClientModal,
      onRegisteInfo: _ctx.registeInfo
    }, null, 8, ["show", "onCloseClientModal", "onRegisteInfo"]),
    _createVNode(_component_ClientShutDownModal, {
      show: _ctx.clientModal.MODAL_CLIENT_SHUTDOWN,
      onCloseClientModal: _ctx.closeClientModal,
      onShutDownTer: _ctx.shutDownTer,
      count: _ctx.state.selectCount
    }, null, 8, ["show", "onCloseClientModal", "onShutDownTer", "count"]),
    _createVNode(_component_ClientRebootModal, {
      show: _ctx.clientModal.MODAL_CLIENT_REBOOT,
      onCloseClientModal: _ctx.closeClientModal,
      onRestartTer: _ctx.restartTer,
      count: _ctx.state.selectCount
    }, null, 8, ["show", "onCloseClientModal", "onRestartTer", "count"]),
    _createVNode(_component_ClientBlackListModal, {
      show: _ctx.clientModal.MODAL_CLIENT_BLACKLIST,
      onCloseClientModal: _ctx.closeClientModal,
      onReloadData: _ctx.reloadData,
      list: _ctx.blacklist
    }, null, 8, ["show", "onCloseClientModal", "onReloadData", "list"]),
    _createVNode(_component_ClientDeleteModal, {
      row: _ctx.currentRow,
      show: _ctx.clientModal.MODAL_CLIENT_DELETE,
      onCloseClientModal: _ctx.closeClientModal,
      onSuccess: _ctx.deleteTerminal
    }, null, 8, ["row", "show", "onCloseClientModal", "onSuccess"]),
    _createVNode(_component_ClientDefencePolicyModal, {
      "group-id": _ctx.options.group_id,
      "defence-strategy": _ctx.defenceStrategy,
      row: _ctx.currentRow,
      show: _ctx.clientModal.MODAL_CLIENT_DEFENCE_POLICY,
      onCloseClientModal: _ctx.closeClientModal
    }, null, 8, ["group-id", "defence-strategy", "row", "show", "onCloseClientModal"]),
    _createVNode(_component_ClientMoveTerminalModal, {
      show: _ctx.clientModal.MODAL_CLIENT_MOVE_TERMINAL,
      onCloseClientModal: _ctx.closeClientModal,
      onMoveTerminal: _ctx.moveTerminal,
      count: _ctx.state.selectCount
    }, null, 8, ["show", "onCloseClientModal", "onMoveTerminal", "count"]),
    _createVNode(_component_MessagePushModal, {
      modelValue: _ctx.clientModal.MODAL_PUSH_MODAL,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.clientModal.MODAL_PUSH_MODAL) = $event)),
      onConfirm: _ctx.messagePushConfirm
    }, null, 8, ["modelValue", "onConfirm"]),
    (_ctx.remoteAssistDialog)
      ? (_openBlock(), _createBlock(_component_RemoteAssist, {
          key: 0,
          "terminal-info": _ctx.currentRow,
          onClose: _ctx.handleRemoteAssistDialogClose,
          onAuthSuccess: _ctx.reloadData
        }, null, 8, ["terminal-info", "onClose", "onAuthSuccess"]))
      : _createCommentVNode("", true),
    _createVNode(_component_TerminalInfo, {
      modelValue: _ctx.terminalInfoVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.terminalInfoVisible) = $event)),
      "terminal-info": _ctx.currentRow,
      onRefresh: _ctx.reloadData
    }, null, 8, ["modelValue", "terminal-info", "onRefresh"]),
    _createVNode(_component_ServiceManage, {
      modelValue: _ctx.serviceManageVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.serviceManageVisible) = $event)),
      "device-id": _ctx.currentRow?.device_id,
      "terminal-type": _ctx.currentRow?.system_type,
      title: _ctx.serviceManageDrawerTitle,
      onSuccess: _ctx.reloadData
    }, null, 8, ["modelValue", "device-id", "terminal-type", "title", "onSuccess"]),
    _createVNode(_component_LocationInfo, {
      modelValue: _ctx.locationInfoVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.locationInfoVisible) = $event)),
      "terminal-info": _ctx.currentRow
    }, null, 8, ["modelValue", "terminal-info"]),
    _createVNode(_component_FleetMap, {
      modelValue: _ctx.fleetMapVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fleetMapVisible) = $event)),
      "default-group-id": _ctx.options.group_id
    }, null, 8, ["modelValue", "default-group-id"])
  ], 64))
}